import styled from 'styled-components';
import Dragger from 'antd/lib/upload/Dragger';
export const StyledCreateEditProductsGallery = styled(Dragger)`
  .ant-upload-text {
    display: flex;
    gap: 5px;
    .gallery-first-text {
      font-size: 14px;
      font-weight: 600;
      color: ${(props) => props.theme.blue};
    }

    .gallery-second-text {
      font-size: 14px;
      color: ${(props) => props.theme.textColor};
      font-weight: 400;
    }
  }

  .ant-upload-drag {
    background: transparent;
    border: none;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23C3C3C3FF' stroke-width='2' stroke-dasharray='8' stroke-dashoffset='9' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 4px;
  }
`;

export const StyledEditCustomImage = styled.div``;

export const StyledCustomImage = styled('div')`
  display: flex;
  padding-top: 30px;
  flex-direction: row;
  font-family: ${(props) => props.theme.fontText};

  .custom-upload-list-item-image {
    width: 150px;
    height: 147px;
  }
  .overlay-wrap {
    position: relative;

    .ant-form-item {
      margin: 0;

      .ant-radio-inner {
        border-radius: 20px;
      }

      .ant-radio-wrapper {
        span {
          padding-inline-start: 2px;
        }
        .ant-radio-inner {
          padding-inline-start: 8px;
        }
      }
    }

    .overlay {
      display: flex;
      align-items: center;
      position: absolute;
      width: 87px;
      height: 24px;
      border-radius: 12px;
      margin: 3px;
      padding-right: 5px;
      background-color: ${(props) => props.theme.white};
      z-index: 1;

      .checkbox-thumbnail {
        font-size: 14px;
        padding: 3px;
        border-radius: 12px;
      }
    }
  }

  .custom-upload-list-item-actions {
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
    .action {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export const StyledCustomUploadList = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 40px;

  .ant-radio-group {
    display: flex;
    flex-direction: row;
    gap: 25px;
  }

  .custom-upload-list-item-container {
    position: absolute;
    display: flex;
    gap: 25px;
    bottom: 0px;
    text-decoration: underline;

    .custom-upload-list-item-actions {
      display: flex;
      width: 150px;
      justify-content: space-between;
    }
  }
`;

export const StyledImagePreviews = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  max-width: 200px;
`;
